// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/** Known HTTP headers. */
export enum HttpHeader {
    Authorization = 'authorization',
    ContentType = 'content-type',
    Date = 'date',
    ETag = 'etag',
    Vary = 'vary',
    OcpApimSubscriptionKey = 'ocp-apim-subscription-key',
    OperationLocation = 'operation-location',
    OperationId = 'operation-id',
    RequestId = 'request-id',
    RequestContext = 'request-context',
    StrictTransportSecurity = 'strict-transport-security',
    TraceParent = 'traceparent',
    TraceState = 'tracestate',
    XApiKey = 'x-api-key',
    XCommit = 'x-commit',
    XContentTypeOptions = 'x-content-type-options',
    XMSAffinityRegion = 'x-ms-affinity-region',
    XMSClientRequestId = 'x-ms-client-request-id',
    XMSUserAgent = 'x-ms-useragent',
    XRatelimitLimit = 'x-ratelimit-limit',
    XRatelimitRemaining = 'x-ratelimit-remaining',
    XRatelimitReset = 'x-ratelimit-reset',
    XSharedLinkId = 'x-shared-link-id',
}
